var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        id: _vm.id,
        label: _vm.label,
        "label-for": `${_vm.id}-input`,
        "label-class": _vm.labelClasses,
      },
    },
    [
      _c(
        "b-input-group",
        { class: _vm.inputGroupSize },
        [
          _vm.icon
            ? _c(
                "b-input-group-prepend",
                [_c("b-input-group-text", [_c("i", { class: _vm.icon })])],
                1
              )
            : _vm._e(),
          _c(
            "b-form-datepicker",
            _vm._g(
              {
                class: _vm.inputClasses,
                attrs: {
                  id: `${_vm.id}-input`,
                  placeholder: _vm.label,
                  state: _vm.feedbackState(),
                  autocomplete: _vm.autocomplete,
                  required: _vm.isRequired,
                  readonly: _vm.readonly,
                  disabled: _vm.isDisabled,
                  "date-format-options": {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  },
                },
                on: {
                  blur: function ($event) {
                    _vm.hadFocus = true
                  },
                },
                model: {
                  value: _vm.innerValue,
                  callback: function ($$v) {
                    _vm.innerValue = $$v
                  },
                  expression: "innerValue",
                },
              },
              _vm.inputListeners
            )
          ),
          _vm.tooltip
            ? _c(
                "b-input-group-append",
                [
                  _c(
                    "b-input-group-text",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { title: _vm.tooltip },
                    },
                    [_c("i", { staticClass: "cui-info font-lg" })]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      this.feedback === "true"
        ? _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.feedbackState() } },
            [_vm._v("\n    " + _vm._s(_vm.feedbackText) + "\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }